import React, { useEffect, useRef } from 'react'
import { useThree } from '@react-three/fiber'
import { Box3, Vector3 } from 'three'

export function CameraUpdater({
  models,
  modelsStructure,
  viewerPrimed,
  controlsRef,
  onSettled,
}) {
  const { camera } = useThree()
  const settledRef = useRef(false)
  const lastStructureRef = useRef(modelsStructure)

  // er zit een prime check in, om geen verschuiving van de camera te krijgen vòòr viewerReady.
  useEffect(() => {
    if (!viewerPrimed) {
      // settledRef zo laten
    }
  }, [viewerPrimed])

  useEffect(() => {
    if (!viewerPrimed) return

    const structureChanged = lastStructureRef.current !== modelsStructure
    if (settledRef.current && !structureChanged) return

    if (models.length > 0 && controlsRef.current && camera) {
      const box = new Box3()
      models.forEach(({ model }) => {
        const modelBox = new Box3().setFromObject(model, true)
        box.union(modelBox)
      })

      const center = new Vector3()
      box.getCenter(center)
      const size = box.getSize(new Vector3())
      const distance = size.length() * 2

      let extra_rotation = 0
      let extra_angle = 0
      if (
        typeof window !== 'undefined' &&
        typeof window.PUPPETEER_DATA !== 'undefined'
      ) {
        if (typeof window.PUPPETEER_DATA.rotation !== 'undefined') {
          extra_rotation = parseFloat(window.PUPPETEER_DATA.rotation)
        }
        if (typeof window.PUPPETEER_DATA.angle !== 'undefined') {
          extra_angle = parseFloat(window.PUPPETEER_DATA.angle)
        }
      }

      const offset = new Vector3(
        extra_rotation,
        Math.max(size.x, size.y, size.z) + extra_angle,
        distance,
      )
      offset.applyAxisAngle(new Vector3(0, -1, 0), Math.PI / 4)

      camera.position.copy(center).add(offset)
      camera.lookAt(center)

      controlsRef.current.target.copy(center)
      controlsRef.current.maxDistance = center.z + distance

      camera.updateProjectionMatrix()
      controlsRef.current.update()

      settledRef.current = true
      lastStructureRef.current = modelsStructure
      onSettled?.()
    }
  }, [models, modelsStructure, viewerPrimed, controlsRef, onSettled, camera])

  return null
}
